/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "@/components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbar from "@/examples/Navbars/DefaultNavbar";
import PageLayout from "@/examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "@/layouts/authentication/components/Footer";
import DashboardNavbar from "../../../../examples/Navbars/DashboardNavbar";

function Anal1({ image, children }) {
  return (
    <PageLayout>
      <MDBox bgColor={"red"} px={2} display={"flex"} mt={0} height="auto" mx="auto">
        <Grid
          container
          bgcolor={"yellowgreen"}
          spacing={1}
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <Grid item xs={12} md={6}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
      <Footer light />
    </PageLayout>
  );

  return (
    <PageLayout>
      <MDBox px={1} width="100%" mt={4} height="auto" mx="auto">
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
      <Footer light />
    </PageLayout>
  );
}

// Typechecking props for the BasicLayout
Anal1.propTypes = {
  image: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Anal1;
